import {IRoutableModule} from '../../router/routing.infra';
import {inviteRouteLoader} from './invite.loader';
import {InviteDesktopView} from '../invite-new/invite-desktop.view';
import {InviteMobileView} from '../invite-mobile/invite-mobile.view';

export default {
    loader: inviteRouteLoader,
    Component: InviteDesktopView,
    MobileComponent: InviteMobileView,
    storeAs: 'inviteStore'
} as IRoutableModule;
